"use client";

import { Fragment, useEffect, useState } from "react";
import Link from "next/link";
import { NAV } from "@/lib/site.data";

// Mobile-only hamburger. The desktop nav (.site-nav) is hidden under 768px, so on
// phones this is the only way into the menu. CTA href differs per surface: the
// homepage scrolls to its in-page booking form (#book), sub-pages go to /apply.
export default function MobileNav({ ctaHref = "/apply" }: { ctaHref?: string }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  // While the menu is open, lock background scroll and mark the document so the
  // page behind can be blurred/dimmed. Cleaned up on close and unmount.
  useEffect(() => {
    const root = document.documentElement;
    if (open) root.classList.add("nav-open");
    else root.classList.remove("nav-open");
    return () => root.classList.remove("nav-open");
  }, [open]);

  return (
    <div className="mnav">
      <button
        type="button"
        className={open ? "mnav-toggle open" : "mnav-toggle"}
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span />
        <span />
        <span />
      </button>

      {open && <button className="mnav-scrim" aria-label="Close menu" onClick={close} />}

      <div className={open ? "mnav-panel open" : "mnav-panel"}>
        {NAV.map((n) => (
          <Fragment key={n.href}>
            {/* Plain anchor for the demo route (3D bundle) and the /opd-ai PHP funnel
                (outside this Next app) so neither is prefetched or client-routed. */}
            {n.href.startsWith("/demo") || n.href.startsWith("/opd-ai") ? (
              <a href={n.href} className="mnav-link" onClick={close}>
                {n.label}
              </a>
            ) : (
              <Link href={n.href} className="mnav-link" onClick={close} prefetch={false}>
                {n.label}
              </Link>
            )}
            {n.href === "/ai-employees" && (
              <details className="mnav-dd" key="ai-training">
                <summary className="mnav-link mnav-dd-summary">AI Training</summary>
                <a className="mnav-link mnav-dd-item" href="/ai-training/institutions/" onClick={close}>
                  For schools &amp; universities
                </a>
                <a className="mnav-link mnav-dd-item" href="/ai-training/business/" onClick={close}>
                  For businesses &amp; teams
                </a>
              </details>
            )}
          </Fragment>
        ))}
        <a href={ctaHref} data-lead-cta data-lead-source="mobile-nav" className="btn btn-primary mnav-cta" onClick={close}>
          Book a free call
        </a>
      </div>
    </div>
  );
}
